import * as React from 'react';
import clsx from 'clsx';
import { UseFormRegister } from 'react-hook-form';
import { genarateNumber } from 'common/method/helper';

// extends React.InputHTMLAttributes<HTMLInputElement>
interface IInputProps {
  label: string;
  iconstart?: JSX.Element;
  iconend?: JSX.Element;
  classInput?: string;
  classparent?: string;
  textError?: string;
  name?: string;
  ref?: any;
  value?: string;
  onChange?: any;
  placeholder: string;
}

const Input = React.forwardRef<
  HTMLInputElement,
  IInputProps &
  React.InputHTMLAttributes<HTMLInputElement> &
  ReturnType<UseFormRegister<any>>
>((props, ref) => {
  const {
    label,
    iconstart,
    iconend,
    classInput,
    classparent,
    textError,
    name,
    value,
    onChange,
    ...resProps
  } = props;
  const randomNum = genarateNumber();

  return (
    <div
      className={clsx({
        [classparent as string]: !!classparent,
        'w-full': !classparent,
      })}
    >
      {!!label && (
        <label
          htmlFor={name + randomNum}
          className="block text-xl md:text-b2xl lg:text-2xl md:!font-medium mb-2 text-L-gray-250"
        >
          {label}
        </label>
      )}
      <div className="relative mt-1 rounded-md shadow-sm w-full">
        {!!iconstart && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            {iconstart}
          </div>
        )}

        <input
          autoComplete="on"
          aria-invalid={!!textError ? 'true' : 'false'}
          id={name + randomNum}
          className={clsx(
            'ltrInsert border border-L-gray-100 outline-none w-full h-12 rounded-2xl px-4 placeholder:text-xl placeholder:text-L-gray-150 bg-L-basic',
            {
              '!border-L-error-150 outline-none': !!textError,
              'pr-10': !!iconstart,
              'pl-10': !!iconend,
              [classInput as string]: classInput,
            }
          )}
          name={name}
          value={value}
          onChange={onChange}
          {...resProps}
          ref={ref}
        />

        {!!iconend && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 z-[100] pr-2">
            {iconend}
          </div>
        )}
      </div>

      <p
        className={clsx(
          'text-L-error-150 dark:text-D-error-150 text-xl transition-all pt-1 min-h-[22px]',
          {
            'pt-1': !!textError,
          }
        )}
      >
        {textError}
      </p>
    </div>
  );
});

export default Input;
